import * as bootstrap from 'bootstrap'
// import "offcanvas-bootstrap/dist/js/bootstrap.offcanvas.js"; 直接複製使用才行

// Import PDF.js (新版本，支援 ESM，無需 unsafe-eval)
import * as pdfjsLib from 'pdfjs-dist';

// 使用相同版本的 worker (5.4.149) - 絕對路徑
pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.mjs';

// 讓 PDF 檢視器可以使用
window.pdfjsLib = pdfjsLib;

console.log('PDF.js loaded:', pdfjsLib.version);
(function(){var a=function(a,b){return function(){return a.apply(b,arguments)}};!function(b,c){var d,e,f;e=function(){function c(c){this.element=c,this._clickEvent=a(this._clickEvent,this),this.element=b(this.element),this.nav=this.element.closest(".nav"),this.dropdown=this.element.parent().find(".dropdown-menu"),this.element.on("click",this._clickEvent),this.nav.closest(".navbar-offcanvas").on("click",function(a){return function(){if(a.dropdown.is(".shown"))return a.dropdown.removeClass("shown").closest(".open").removeClass("open")}}(this))}return c.prototype._clickEvent=function(a){return this.dropdown.hasClass("shown")||a.preventDefault(),a.stopPropagation(),b(".dropdown-toggle").not(this.element).closest(".open").removeClass("open").find(".dropdown-menu").removeClass("shown"),this.dropdown.toggleClass("shown"),this.element.parent().toggleClass("open")},c}(),f=function(){function d(c,d,e,f){this.button=c,this.element=d,this.location=e,this.offcanvas=f,this._getFade=a(this._getFade,this),this._getCss=a(this._getCss,this),this._touchEnd=a(this._touchEnd,this),this._touchMove=a(this._touchMove,this),this._touchStart=a(this._touchStart,this),this.endThreshold=130,this.startThreshold=this.element.hasClass("navbar-offcanvas-right")?b("body").outerWidth()-60:20,this.maxStartThreshold=this.element.hasClass("navbar-offcanvas-right")?b("body").outerWidth()-20:60,this.currentX=0,this.fade=!!this.element.hasClass("navbar-offcanvas-fade"),b(document).on("touchstart",this._touchStart),b(document).on("touchmove",this._touchMove),b(document).on("touchend",this._touchEnd)}return d.prototype._touchStart=function(a){if(this.startX=a.originalEvent.touches[0].pageX,this.element.is(".in"))return this.element.height(b(c).outerHeight())},d.prototype._touchMove=function(a){var c;if(b(a.target).parents(".navbar-offcanvas").length>0)return!0;if(this.startX>this.startThreshold&&this.startX<this.maxStartThreshold){if(a.preventDefault(),c=a.originalEvent.touches[0].pageX-this.startX,c=this.element.hasClass("navbar-offcanvas-right")?-c:c,Math.abs(c)<this.element.outerWidth())return this.element.css(this._getCss(c)),this.element.css(this._getFade(c))}else if(this.element.hasClass("in")&&(a.preventDefault(),c=a.originalEvent.touches[0].pageX+(this.currentX-this.startX),c=this.element.hasClass("navbar-offcanvas-right")?-c:c,Math.abs(c)<this.element.outerWidth()))return this.element.css(this._getCss(c)),this.element.css(this._getFade(c))},d.prototype._touchEnd=function(a){var c,d,e;return b(a.target).parents(".navbar-offcanvas").length>0||(d=!1,e=a.originalEvent.changedTouches[0].pageX,Math.abs(e)!==this.startX?(c=this.element.hasClass("navbar-offcanvas-right")?Math.abs(e)>this.endThreshold+50:e<this.endThreshold+50,this.element.hasClass("in")&&c?(this.currentX=0,this.element.removeClass("in").css(this._clearCss()),this.button.removeClass("is-open"),d=!0):Math.abs(e-this.startX)>this.endThreshold&&this.startX>this.startThreshold&&this.startX<this.maxStartThreshold?(this.currentX=this.element.hasClass("navbar-offcanvas-right")?-this.element.outerWidth():this.element.outerWidth(),this.element.toggleClass("in").css(this._clearCss()),this.button.toggleClass("is-open"),d=!0):this.element.css(this._clearCss()),this.offcanvas.bodyOverflow(d)):void 0)},d.prototype._getCss=function(a){return a=this.element.hasClass("navbar-offcanvas-right")?-a:a,{"-webkit-transform":"translate3d("+a+"px, 0px, 0px)","-webkit-transition-duration":"0s","-moz-transform":"translate3d("+a+"px, 0px, 0px)","-moz-transition":"0s","-o-transform":"translate3d("+a+"px, 0px, 0px)","-o-transition":"0s",transform:"translate3d("+a+"px, 0px, 0px)",transition:"0s"}},d.prototype._getFade=function(a){return this.fade?{opacity:a/this.element.outerWidth()}:{}},d.prototype._clearCss=function(){return{"-webkit-transform":"","-webkit-transition-duration":"","-moz-transform":"","-moz-transition":"","-o-transform":"","-o-transition":"",transform:"",transition:"",opacity:""}},d}(),c.Offcanvas=d=function(){function d(c){var d;this.element=c,this.bodyOverflow=a(this.bodyOverflow,this),this._sendEventsAfter=a(this._sendEventsAfter,this),this._sendEventsBefore=a(this._sendEventsBefore,this),this._documentClicked=a(this._documentClicked,this),this._close=a(this._close,this),this._open=a(this._open,this),this._clicked=a(this._clicked,this),this._navbarHeight=a(this._navbarHeight,this),d=!!this.element.attr("data-target")&&this.element.attr("data-target"),d?(this.target=b(d),this.target.length&&!this.target.hasClass("js-offcanvas-done")&&(this.element.addClass("js-offcanvas-has-events"),this.location=this.target.hasClass("navbar-offcanvas-right")?"right":"left",this.target.addClass(this._transformSupported()?"offcanvas-transform js-offcanvas-done":"offcanvas-position js-offcanvas-done"),this.target.data("offcanvas",this),this.element.on("click",this._clicked),this.target.on("transitionend",function(a){return function(){if(a.target.is(":not(.in)"))return a.target.height("")}}(this)),b(document).on("click",this._documentClicked),this.target.hasClass("navbar-offcanvas-touch")&&new f(this.element,this.target,this.location,this),this.target.find(".dropdown-toggle").each(function(){return new e(this)}),this.target.on("offcanvas.toggle",function(a){return function(b){return a._clicked(b)}}(this)),this.target.on("offcanvas.close",function(a){return function(b){return a._close(b)}}(this)),this.target.on("offcanvas.open",function(a){return function(b){return a._open(b)}}(this)))):console.warn("Offcanvas: `data-target` attribute must be present.")}return d.prototype._navbarHeight=function(){if(this.target.is(".in"))return this.target.height(b(c).outerHeight())},d.prototype._clicked=function(a){return a.preventDefault(),this._sendEventsBefore(),b(".navbar-offcanvas").not(this.target).trigger("offcanvas.close"),this.target.toggleClass("in"),this.element.toggleClass("is-open"),this._navbarHeight(),this.bodyOverflow()},d.prototype._open=function(a){if(a.preventDefault(),!this.target.is(".in"))return this._sendEventsBefore(),this.target.addClass("in"),this.element.addClass("is-open"),this._navbarHeight(),this.bodyOverflow()},d.prototype._close=function(a){if(a.preventDefault(),!this.target.is(":not(.in)"))return this._sendEventsBefore(),this.target.removeClass("in"),this.element.removeClass("is-open"),this._navbarHeight(),this.bodyOverflow()},d.prototype._documentClicked=function(a){var c;if(c=b(a.target),!c.hasClass("offcanvas-toggle")&&0===c.parents(".offcanvas-toggle").length&&0===c.parents(".navbar-offcanvas").length&&!c.hasClass("navbar-offcanvas")&&this.target.hasClass("in"))return a.preventDefault(),this._sendEventsBefore(),this.target.removeClass("in"),this.element.removeClass("is-open"),this._navbarHeight(),this.bodyOverflow()},d.prototype._sendEventsBefore=function(){return this.target.hasClass("in")?this.target.trigger("hide.bs.offcanvas"):this.target.trigger("show.bs.offcanvas")},d.prototype._sendEventsAfter=function(){return this.target.hasClass("in")?this.target.trigger("shown.bs.offcanvas"):this.target.trigger("hidden.bs.offcanvas")},d.prototype.bodyOverflow=function(a){if(null==a&&(a=!0),this.target.is(".in")?b("body").addClass("offcanvas-stop-scrolling"):b("body").removeClass("offcanvas-stop-scrolling"),a)return this._sendEventsAfter()},d.prototype._transformSupported=function(){var a,b,c,d;return b=document.createElement("div"),d="translate3d(0px, 0px, 0px)",c=/translate3d\(0px, 0px, 0px\)/g,b.style.cssText="-webkit-transform: "+d+"; -moz-transform: "+d+"; -o-transform: "+d+"; transform: "+d,a=b.style.cssText.match(c),null!=a.length},d}(),b.fn.bsOffcanvas=function(){return this.each(function(){return new d(b(this))})},b(function(){return b('[data-toggle="offcanvas"]').each(function(){return b(this).bsOffcanvas()}),b(c).on("resize",function(){return b(".navbar-offcanvas.in").each(function(){return b(this).height("").removeClass("in")}),b(".offcanvas-toggle").removeClass("is-open"),b("body").removeClass("offcanvas-stop-scrolling")}),b(".offcanvas-toggle").each(function(){return b(this).on("click",function(a){var c,d;if(!b(this).hasClass("js-offcanvas-has-events")&&(d=b(this).attr("data-target"),c=b(d)))return c.height(""),c.removeClass("in"),b("body").css({overflow:"",position:""})})})})}(window.jQuery,window)}).call(this);

import Swiper, { Autoplay, Navigation, Pagination, Controller, EffectFade } from 'swiper';
import "swiper/swiper-bundle.min.css";

import retina from 'retinajs';
window.addEventListener('load', retina);

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
Fancybox.bind('[data-fancybox="gallery"]', {});

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// detect if mobile browser. regex -> http://detectmobilebrowsers.com
var isMobile = (function (a) { return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)) })(navigator.userAgent || navigator.vendor || window.opera);

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('[data-bs-toggle="tab"]')
  .not('[data-bs-toggle="collapse"]')
  .on('click', function (event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function () {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });

// 右下角 go to top 功能
$(function(){
  let topButton = document.getElementsByClassName("btn--top")[0];

  window.onscroll = function () {
    scrollFunction()
  };
  function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      topButton.style.opacity = 1;
    } else {
      topButton.style.opacity = 0;
    }
  }

  $(".btn--top").on("click", function() {
    $(window).scrollTop(0);
  })
});

// 滑入淡入
// $(function(){
//   $(".scroll-in").each(function () {
//     gsap.set(this, {
//       opacity: 0,
//       y: 75
//     });
//     gsap.to(this, {
//       opacity: 1,
//       y: 0,
//       duration: 1.5,
//       scrollTrigger: {
//         trigger: this,
//         start: "top bottom",
//         end: "bottom top",
//         scrub: false,
//         markers: false,
//         offset: -75,
//       },
//     });
//   });
// });

$(function () {
  let url = location.href.replace(/\/$/, "");

  if (location.hash) {
    const hash = url.split("#");
    $('.nav-tabs-hash [data-bs-target="#' + hash[1] + '"]').tab("show");
    // url = location.href.replace(/\/#/, "#");
    // history.replaceState(null, null, url);
    setTimeout(function(){
      $(window).scrollTop(0);
    }, 400);
  }

  $('.nav-tabs-hash [data-bs-toggle="tab"]').on("click", function () {
    $('.navbar-collapse').collapse('hide');
    let newUrl;
    const hash = $(this).attr("data-bs-target");
    newUrl = url.split("#")[0] + hash;
    newUrl += "/";
    history.replaceState(null, null, newUrl);
  });


  // 在 Blog 頁時，按下選單 Blog 子選單時會重整頁面。
  $(".hash-refresh").on("click", function(e) {
    if (window.location.href.indexOf("blog.html") != -1) {
      e.preventDefault();
      window.location.href = this.href.substr(this.href.indexOf("#"));
      location.reload();
    }
  });
});

//偵測為IE時變更滑鼠滾輪模式
if(navigator.userAgent.match(/Trident\/7\./)) { // if IE
  $('body').on("mousewheel", function (event) {
    // remove default behavior
    event.preventDefault(); 

    //scroll without smoothing
    var wheelDelta = event.wheelDelta;
    var currentScrollPosition = window.scrollY;
    window.scrollTo(0, currentScrollPosition - wheelDelta);
  });
}

// $(function () {
//   var header = $('.header');
//   var content = $('.wrap-header');
//   var origOffsetY = header.offset().top+1;

//   function scroll() {    
//     if ($(window).scrollTop() >= origOffsetY) {
//       header.addClass('sticky');
//       content.addClass('header-padding');
//     } else {
//       header.removeClass('sticky');
//       content.removeClass('header-padding');
//     }
//   }

//   $(window).on("scroll", scroll);
// });

// index JS
$(function () {
  // 沒有首頁元件就離開
  if ($('.index_swiper-container').length == 0) return;

  let indexSwiper = new Swiper('.index_swiper-container', {
    modules: [ Autoplay, Pagination, EffectFade, Controller ],
    speed: 2000,
    loop: true,
    // effect: 'fade',
    // fadeEffect: {
    //   crossFade: true
    // },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });
  
  let indexDescSwiper = new Swiper('.index_desc-swiper-container', {
    modules: [ Autoplay, Pagination, EffectFade, Controller ],
    loop: true,
    // effect: 'fade',
    // fadeEffect: {
    //   crossFade: true
    // }
  });
  
  indexSwiper.controller.control = indexDescSwiper;
  indexDescSwiper.controller.control = indexSwiper;
  
  // 首頁 banner 淡入入場
  // gsap.from(".index_swiper-container", {opacity: 0, y: -75, duration: 1.5});
  // if(isMobile) {
  //   gsap.from(".index_desc-swiper-container", {opacity: 0, y: -75, duration: 1.5});
  // } else {
  //   gsap.from(".index_desc-swiper-container", {opacity: 0, x: 75, duration: 1.5, delay: 1});
  // }
});

// Panel PC 頁的 產品 filter 功能
const filterSelect = document.querySelector(".filter-select");
const filterItems = document.querySelectorAll(".filter-item");
if(filterSelect) {
  filterSelect.addEventListener("change", () => {
    const filter = filterSelect.value;

    filterItems.forEach((item) => {
      if (filter === "all" || item.classList.contains(filter)) {
        item.classList.remove("d-none");
      } else {
        item.classList.add("d-none");
      }
    });
  });
}

import './download-list.js';
import './product-tabs.js';
import './pdf-viewer.js';
// import './product.js';